var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 487.43 456.19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19 0l188.18 251.67L0 456.2h42.62l165.8-179.1 134 179.11h145L288.64 190.43 464.91 0h-42.62L269.6 164.92 146.22 0zm62.68 31.4h66.63l294.21 393.4H358.1z",
    fill: "currentColor"
  })));
}
export default SvgTwitterX;